var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-4",staticStyle:{"padding-top":"30px","padding-left":"10px","color":"blue"}},[_vm._v("＊は必須入力です")])}
var staticRenderFns = []

export { render, staticRenderFns }